import { OnInit } from '@angular/core';
var AngelComponent = /** @class */ (function () {
    function AngelComponent() {
    }
    AngelComponent.prototype.ngOnInit = function () {
    };
    return AngelComponent;
}());
export { AngelComponent };
